import { app } from "hyperapp";
import account from "../account";
import actions from "./actions";
import view from "./view";

/**
 * View-loader component for player in the masther
 * @param {DOMNode} el Node to bind to
 */
export default function mastheadPlayer(el) {
  if (el.getAttribute("initialised") === "true") {
    return;
  }
  el.setAttribute("initialised", "true");
  const accountSet = account();
  const initialState = {
    destroyed: false,
    title: null,
    subtitle: null,
    isPlaying: false,
    isOpen: true,
    isReady: true,
    isLive: true,
    isNull: true,
    offscreen: false,
    account: accountSet
  };
  let instance = app(initialState, actions, view, el);
  return {
    destroy: () => {
      instance.destroy();
      instance = null;
    }
  };
}
